export function isPortrait(img: any) {
  var w = img.naturalWidth || img.width;
  var h = img.naturalHeight || img.height;
  return (h > w);
}